var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PictureHeader',{attrs:{"img_header":_vm.header_image,"header":"ตั้งค่ารูปภาพเว็บไซต์","link_back":"managewebsite"}}),_c('MenuPicture'),_c('Banner_setting')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }